import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function PorodicnoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Porodično pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Porodično pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Porodično pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 5
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Porodično pravo ima za cilj upoznavanje studenata sa osnovnim
                teoretskim pitanjima i pozitivno pravnim rešenjima koja se
                javljaju u materiji braka, roditeljstva i starateljstva.
                Studentima će se ukazati na posebni postupak koji se primenjuje
                u porodičnim odnosima zbog njihove specifičnosti u odnosu na
                opšte odredbe Zakona o parničnom postupku. Cilj predmeta je
                sticanje znanja o uporednim zakonodavnim rešenjima, kao i
                domaćoj i stranoj sudskoj praksi, u cilju boljeg razumevanja
                porodičnih pravnih odnosa.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Krajnji ishod predmeta Porodično pravo je da obezbedi studentima
                neophodna teorijska znanja iz oblasti porodičnog prava i upozna
                ih sa osnovnim pojmovima ove grane prava. Studenti će biti
                sposobni da rešavaju praktične probleme vezane za ovu oblast,
                prepoznaju značenje najvažnijih instituta Porodičnog prava i
                primene teorijska znanja na konkretne pravne odnose.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
              </p>
              <ul className="values-section">
                <li>
                  Pojam i vrste porodice; srodstvo; lično ime; izvori porodičnog
                  prava; cilj, sadržina i struktura porodičnog zakona
                </li>
                <li>
                  Bračno pravo; sklapanje braka; dejstva braka; prestanak braka;
                  vanbračna zajednica; zajednica lica istog pola
                </li>
                <li>
                  Prava djece bez roditeljskog prava; starateljstvo i usvojenje;
                  hraniteljstvo
                </li>
                <li>
                  Imovinski odnosi članova porodice; zaštita od nasilja u
                  porodici
                </li>
                <li>
                  Posebni postupci za razvod braka, izdržavanje bračnih drugova,
                  roditelja i djece; medijacija u bračno-imovinskim sporovima
                </li>
                <li>Posebni postupak kod utvrđivanja i osporavanja očinstva</li>
              </ul>
              <p>
                <strong>Praktična nastava:</strong>
              </p>
              <ul className="values-section">
                <li>Analiza sudske prakse</li>
                <li>Pisanje tužbi iz domena porodičnih odnosa</li>
                <li>Pisanje ugovora koji se tiču porodičnih odnosa</li>
                <li>Debate</li>
              </ul>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vežbe,
                samostalni rad (seminarski rad i interaktivna nastava).
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P+1V</td>
                    <td>
                      Osnovni pojmovi o porodičnom pravu; pojam, predmet i metod
                      porodičnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P+1V</td>
                    <td>Osnovna načela porodičnog prava</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P+1V</td>
                    <td>
                      Izvori porodičnog prava: neposredni, osnovni, dopunski,
                      posredni izvori porodičnog prava
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P+1V</td>
                    <td>
                      Porodica kao pravna ustanova; struktura porodične veze;
                      srodstvo u porodici
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P+1V</td>
                    <td>
                      Osnovni pojmovi o bračnom pravu; načela bračnog prava;
                      dejstva braka; prestanak braka
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>3P+1V</td>
                    <td>
                      Pravno uređenje vanbračne zajednice; Praktična nastava –
                      analiza sudske prakse
                    </td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P+1V</td>
                    <td>Odnosi roditelja i djece; materinstvo, očinstvo</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P+1V</td>
                    <td>
                      Bračno, vanbračno i usvojeno dijete; prava djeteta;
                      dužnosti djeteta
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P+1V</td>
                    <td>
                      Poništenje braka; Tužba za poništenje braka; Praktična
                      nastava – pisanje tužbi iz domena porodičnih odnosa,
                      analiza sudske prakse
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>3P+1V</td>
                    <td>
                      Hraniteljstvo i starateljstvo; zasnivanje, formalni i
                      materijalni uslovi
                    </td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P+1V</td>
                    <td>Izdržavanje i vrste izdržavanja</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P+1V</td>
                    <td>
                      Imovinski odnosi između članova porodice; supružnika,
                      vanbračnih partnera, djece i roditelja
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P+1V</td>
                    <td>
                      Nasilje u porodici; Praktična nastava – pisanje ugovora
                      koji se tiču porodičnih odnosa, analiza sudske prakse
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vežbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 3 h</td>
                            <td>Ukupno: 80 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15 h</td>
                            <td>Nastava + završni ispit: 60 č</td>
                          </tr>
                          <tr>
                            <td>Vežbe: 1 č / 0.45 h</td>
                            <td>Priprema i ovjera semestra: 6 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PorodicnoPravo;
